import situation from '@/locales/it/tests/situation';
import problems from '@/locales/it/tests/problems';
import resources from '@/locales/it/tests/resources';

export default {
  home: {
    title: 'Fai il test',
  },
  result: {
    title: 'Il tuo risultato',
    nextTests: 'Ancora più test per te:',
  },
  situation: {
    title: 'Test di pronto soccorso',
    ...situation,
  },
  problems: {
    title: 'Test di soluzione del problema',
    ...problems,
  },
  resources: {
    title: 'Test delle capacità',
    ...resources,
  },
  ressources: {
    title: 'Test delle capacità',
    ...resources,
  },
  email: {
    title: 'Ricevere il risultato via email',
    label: 'Il tuo indirizzo di posta elettronica',
    validators: {
      required: 'Necessitiamo l\'inserimento della email',
      valid: 'Questo è un indirizzo email non valido',
    },
    notification: {
      sending: 'Email verrà inviata...',
      sent: 'Email inviata 🎉',
    },
    template: {
      subject: {
        situation: 'Pronto soccorso per te | profemina',
        problems: 'La tua decisione | profemina',
        resources: 'Le tue capacità | profemina',
        ressources: 'Le tue capacità | profemina',
      },
      cta: '',
      greeting: 'Buongiorno,',
      message: 'siamo molto contente che tu ci abbia contattato e speriamo di poterti aiutare un pò con questa valutazione. Qui puoi rileggere in tranquillità il tuo risultato individuale.',
      signatureGreeting: 'Ti auguriamo il meglio per il tuo futuro!<br>Cari saluti,',
      signature: 'Il tuo team di consulenza <i>profemina</i>',
      ps: 'PS: Se hai altre domande, siamo sicure che gli articoli sulla nostra homepage, ti aiuteranno a trovare altre informazioni necessarie per prendere una buona decisione.',
      contact: 'CONSULENZA PROFEMINA<br><br>Informazioni, consulenza e aiuto per donne incinte: <a href="https://www.profemina.org/it-it/">www.profemina.org</a>',
      footer: 'Questo servizio di consulenza digitale è messo a disposizione da:<br>Profemina International Impresa Sociale S.r.l. • Via dei Portici 76 • 39100 Bolzano<br>Iscrizione al registro delle imprese di Bolzano • Numero di iscrizione al registro delle imprese, codice fiscale e partita IVA: 03117840219<br>Rappresentante autorizzato: Kristijan Aufiero, amministratore unico • <a href="https://www.profemina.org/it-it/note-legali">Note legali</a><br><br>IL NOSTRO SERVIZIO DI CONSULENZA:<br><i>profemina</i> è un servizio internazionale di consulenza indipendente, altamente qualificato, di utilità pubblica per donne in crisi a causa di una gravidanza. Attraverso informazioni oggettive, e una consulenza eccellente e sempre più diversificata così come un sostegno concreto, desideriamo rendere possible alle donne che si trovano in un conflitto per una gravidanza di prendere una decisione indipendente e autodeterminata.<br>Dalle più di 100.000 donne, che si sono avvalse della nostra consulenza, abbiamo imparato che la pressione esterna delle circostanze e delle persone è la causa più comune di un conflitto per una gravidanza e della decisione di abortire.<br>Il desiderio di <i>profemina</i> è di stare vicino alle donne gravide in difficoltà ed elaborare un alternativa valida all\'aborto con e per tutte le DONNE CHE LO DESIDERANO, permettendo loro di prendere una decisione LIBERA.<br><br>Il nostro lavoro è finanziato esclusivamente dalle donazioni private dei nostri sostenitori che hanno a cuore le donne incinte in difficoltà. Pertanto, la nostra consulenza è gratuita al 100% per ogni donna che cerca consiglio e aiuto.<br><br>Maggiori informazioni sui principi del nostro lavoro <a href="https://www.profemina.org/it-it/chi-siamo/il-nostro-lavoro">sono consultabili qui</a>.<br><br>INFORMATIVA SULLA PROTEZIONE DEI DATI:<br>Tutti i dati e le informazioni verranno trattati in maniera strettamente riservata, non verranno trasmessi a terzi non autorizzati essendo protetti dal RGPD (Regolamento Generale sulla Protezione dei Dati)! Tutte le informazioni sul trattamento dei dati in particolare quelle relative al Regolamento Generale sulla Protezione dei Dati (RGPD) <a href="https://www.profemina.org/it-it/protezione-dati-personali">sono consultabili qui</a>.<br><br>INFORMAZIONI SULLA RISERVATEZZA:<br>La presente e-mail e la relativa documentazione (ove presente) devono essere utilizzate dai destinatari solo per gli scopi previsti e contengono delle informazioni che per il diritto vigente siano riservate e non possano essere rese note.<br>Qualora non siate i destinatari previsti della presente e-mail viene fatto espresso divieto di rendere noto l\'invio della presente, di riprodurla, distribuirla o divulgarla o di farne qualsiasi altro uso. L\'invio della presente e-mail ad altre persone in qualità di destinatari previsti non sottintende la rinuncia ai diritti esistenti. Se avete ricevuto questa e-mail per errore, vi preghiamo di informare immediatamente il mittente inviando una e-mail di risposta corrispondente e di cancellare immediatamente questa e-mail dal vostro sistema.',
    },
  },
  rating: {
    title: 'Ci rallegriamo del tuo Feedback 🤗',
    question1: '<strong>Questo test ti è stato d\'aiuto nel tuo processo decisionale?</strong>',
    question2: '<strong>Ti sei sentita a tuo agio durante la consulenza?</strong>',
    question3: '<strong>Faresti uso nuovamente della nostra app?</strong>',
    textarea: {
      question: '<strong>C\'è qualcosa che vorresti comunicarci?</strong>',
      label: 'La tua osservazione (opzionale)',
    },
    processing: 'Stiamo elaborando la valutazione..',
    thanks: 'Mille grazie per la tua valutazione 🤗',
  },
  welcome: 'Benvenuta nella app del test di <i>profemina</i>',
  language_switcher: {
    de: 'Deutsch',
    en: 'Englisch',
    pt: 'Portugiesisch',
    it: 'Italienisch',
  },
  bottom_bar: {
    next: 'Avanti',
    advice: 'Il mio risultato',
  },
  refreshApp: {
    title: '<i>profemina</i> sta migliorando 🎉',
    description: 'È disponibile una nuova "versione". Clicca su "aggiorna" per rimanere aggiornata.',
    button: 'aggiorna',
  },
  loading: 'Stiamo creando la tua consulenza individuale',
  notFound: {
    title: '404 - Pagina non trovata',
    subtitle: 'Ops! Scusa...',
    text: 'O noi ti abbiamo condotto sulla strada sbagliata, o tu hai preso la strada sbagliata....',
  },
  connectivity: {
    offline: 'Purtroppo sei andata offline..',
    online: 'Che bello, sei di nuovo online 🤗',
  },
};
